<template>
  <div class="capitalManageDetail">
    <div class="wrap">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.applicantIdName"
          class="ggInput"
          input-align="right"
          readonly
          label="申请人："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="createTime"
          label="申请日期："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <!-- 所属项目 -->
      <van-cell-group class="itemSite baseNone beizhu">
        <van-field
          v-model="projectName"
          :required="editType"
          type="textarea"
          label="所属项目："
          placeholder="请选择"
          readonly
          input-align="right"
          rows="1"
          :is-link="editType"
          autosize
        />
      </van-cell-group>
      <div v-if="projectName">
        <van-cell-group class="itemSite baseNone beizhu">
          <van-field
            :value="
              incomeAndExpenses.contractAmount != null
                ? incomeAndExpenses.contractAmount
                : 0
            "
            label="合同金额："
            readonly
            class="ggInput"
            input-align="right"
          />
        </van-cell-group>
        <van-cell-group class="itemSite baseNone beizhu">
          <van-field
            v-model="incomeAndExpenses.expenses"
            label="项目支出："
            @click="
              parseFloat(incomeAndExpenses.expenses) > 0
                ? getMoneyDetail('expend')
                : ''
            "
            :is-link="parseFloat(incomeAndExpenses.expenses) > 0"
            readonly
            class="ggInput"
          />
        </van-cell-group>

        <div
          :class="[
            'projectIncome',
            incomeAndExpenses.contractAmount != null &&
            parseFloat(incomeAndExpenses.contractAmount) > 0 &&
            incomeAndExpenses.income != null &&
            parseFloat(incomeAndExpenses.income) > 0
              ? 'changeW'
              : '',
          ]"
        >
          <van-cell-group class="itemSite baseNone beizhu">
            <van-field
              v-model="incomeAndExpenses.income"
              label="项目到账："
              @click="
                parseFloat(incomeAndExpenses.income) > 0
                  ? getMoneyDetail('income')
                  : ''
              "
              readonly
              :is-link="parseFloat(incomeAndExpenses.income) > 0"
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="marketPercent"
              label="营销成本限额比例（%）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="marketingCost"
              label="营销成本限额（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="marketingCostTotal"
              label="累计营销已支出成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="remainMarketingCost"
              label="剩余营销可支出成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="technologyPercent"
              label="技术成本限额比例（%）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="technicalCost"
              label="技术成本限额（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="technicalCostTotal"
              label="累计技术已支出成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="remainTechnicalCost"
              label="剩余技术可支出成本元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="bidCostTotal"
              label="累计投标成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="receptionPercent"
              label="招待成本限额比例（%）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="receptionCost"
              label="招待成本限额（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="receptionCostTotal"
              label="累计已支出招待费（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="remainReceptionCost"
              label="剩余可支出招待费（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
        </div>
      </div>
      <!-- <van-cell-group class="itemSite baseNone beizhu">
        <van-field
          v-model="propertyData.typeName"
          :required="editType"
          type="textarea"
          label="资金用途："
          placeholder="请选择"
          :is-link="editType"
          @click="showTypePickerFun"
          readonly
          input-align="right"
          rows="1"
          autosize
        />
      </van-cell-group> -->
      <van-cell-group class="baseNone baseSalary beizhu moreText">
        <van-field
          v-model="propertyData.firstTypeName"
          label="资金用途类别："
          readonly
          type="textarea"
          rows="1"
          autosize
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.secondTypeName"
          label="二级类别："
          readonly
          type="textarea"
          rows="1"
          autosize
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.thirdTypeName"
          label="三级类别："
          readonly
          type="textarea"
          rows="1"
          autosize
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="itemSite baseNone beizhu">
        <van-field
          v-model="propertyData.companyTypeName"
          :required="editType"
          label="付款类型："
          placeholder="请选择"
          :is-link="editType"
          readonly
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group
        class="baseNone baseSalary"
        v-if="propertyData.companyType == 'inner'"
      >
        <van-field
          :required="editType"
          v-model="selectPeopleNames"
          placeholder="请选择"
          readonly
          :is-link="editType"
          class="ggInput"
          label="收款人："
          type="textarea"
          rows="1"
          autosize
        />
      </van-cell-group>
      <div
        class="claimDetailMain"
        v-if="propertyData.companyType == 'inner' && innerShow"
      >
        <p class="tit">付款明细</p>
        <van-cell-group class="claimDetailBox">
          <div class="claimDetailLists">
            <div
              class="claimItem"
              v-for="(item, index) in propertyData.accountInfoParams"
              :key="index"
            >
              <van-cell-group class="baseNone baseSalary">
                <van-field
                  :required="editType"
                  type="number"
                  v-model="item.receiveAmount"
                  placeholder="请输入金额"
                  :readonly="!editType"
                  class="ggInput"
                  :label="item.staffName + '：'"
                />
              </van-cell-group>
              <div
                class="delectClaim"
                v-if="propertyData.accountInfoParams.length > 0 && editType"
              >
                <van-icon name="cross" @click="delectInnerClaim(index)" />
              </div>
            </div>
          </div>
        </van-cell-group>
      </div>
      <div class="claimDetailMain" v-if="propertyData.companyType == 'outer'">
        <p class="tit">付款明细</p>
        <van-cell-group class="claimDetailBox">
          <div class="claimDetailLists">
            <div
              class="claimItem"
              v-for="(item, index) in propertyData.accountInfoParams"
              :key="index"
            >
              <van-cell-group class="baseNone baseSalary">
                <van-field
                  :required="editType"
                  type="number"
                  v-model="item.receiveAmount"
                  placeholder="请输入...  "
                  :readonly="!editType"
                  class="ggInput"
                  label="金额："
                />
              </van-cell-group>

              <van-cell-group
                class="baseNone baseSalary beizhu"
                v-if="item.collectingCompany != null"
              >
                <van-field
                  rows="1"
                  autosize
                  type="textarea"
                  :required="editType"
                  v-model="item.collectingCompany"
                  placeholder="请输入...  "
                  :readonly="!editType"
                  class="ggInput"
                  label="收款单位："
                />
              </van-cell-group>
              <van-cell-group
                class="baseNone baseSalary"
                v-if="item.paymentTypeName != null"
              >
                <van-field
                  :required="editType"
                  v-model="item.paymentTypeName"
                  placeholder="请选择"
                  @click="showPaymentType(index)"
                  readonly
                  :is-link="editType"
                  class="ggInput"
                  label="付款方式："
                />
              </van-cell-group>

              <van-cell-group
                class="baseNone baseSalary"
                v-if="item.paymentType == 'zz' || item.paymentType == 'hp'"
              >
                <van-field
                  :required="editType"
                  v-model="item.bankAccount"
                  placeholder="请输入...  "
                  :readonly="!editType"
                  class="ggInput"
                  label="开户银行："
                />
              </van-cell-group>
              <van-cell-group
                class="baseNone baseSalary"
                v-if="item.paymentType == 'zz' || item.paymentType == 'hp'"
              >
                <van-field
                  :required="editType"
                  v-model="item.depositBank"
                  placeholder="请输入...  "
                  :readonly="!editType"
                  class="ggInput"
                  label="银行账户："
                />
              </van-cell-group>
            </div>

            <div
              class="delectClaim"
              v-if="propertyData.accountInfoParams.length > 1 && editType"
            >
              <van-icon name="cross" @click="delectClaim(index)" />
            </div>
          </div>
          <div class="addBtn" v-if="editType">
            <van-button
              icon="plus"
              type="primary"
              class="addClaim"
              size="small"
              @click="addClaim"
              >添加明细</van-button
            >
          </div>
        </van-cell-group>
      </div>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="propertyData.amount"
          clearable
          :required="editType"
          class="ggInput"
          input-align="right"
          readonly
          type="number"
          label="申请金额（元）："
          placeholder="0"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.reason"
          clearable
          rows="1"
          class="ggInput"
          input-align="right"
          :readonly="!editType"
          autosize
          type="textarea"
          :required="editType"
          label="申请原因："
          placeholder="请输入...  "
        />
      </van-cell-group>
      <van-cell-group
        class="baseNone beizhu"
        v-if="propertyData.remarks != null"
      >
        <van-field
          v-model="propertyData.remarks"
          rows="1"
          autosize
          label="备注"
          type="textarea"
          :placeholder="editType ? '请输入...  ' : ''"
          :readonly="!editType"
        />
      </van-cell-group>
      <wx-file-view
        v-if="is_weixn"
        :filesData="propertyData"
        :editType="editType"
        class="fileview"
      ></wx-file-view>
      <!-- 原生附件 -->
      <file-view
        v-else
        :filesData="propertyData"
        :editType="editType"
        class="fileview"
      ></file-view>
    </div>
    <!-- 项目支出或收入明细 -->
    <van-popup
      v-model="showProjectMoneyPicker"
      round
      closeable
      close-icon="close"
      position="bottom"
      class="moneyPicker"
    >
      <ul v-if="moneydetailList.length != '0'">
        <li v-for="item in moneydetailList" :key="item.id">
          <div class="incomeInfo">
            <p>
              {{ pickerType == "income" ? "到账类型" : "支出类型" }}：{{
                item.typeName
              }}
            </p>
            <p>
              {{ pickerType == "income" ? "到账时间" : "支出时间" }}：{{
                item.createTime
              }}
            </p>
            <p>
              {{ pickerType == "income" ? "到账金额" : "支出金额" }}：{{
                item.amount
              }}元
            </p>
            <p>备注：{{ item.remarks }}</p>
          </div>
        </li>
      </ul>

      <div class="nonePage" v-if="moneydetailList.length == '0' && refreshing">
        <img :src="baseUrl + 'empty.png'" alt />
        <p>暂无数据</p>
      </div>
    </van-popup>

    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");

const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
import { dateFormat, getDictList, isEdit } from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "capitalManage-detail",
  props: {
    id: {
      //借款记录id
      type: String,
      default: "",
    },
  },
  data() {
    return {
      propertyData: {
        amount: "", //申请金额
        projectId: "", //所属项目code

        companyTypeName: "", //付款类型Name
        companyType: "", //付款类型

        reason: "", //申请原因
        remarks: "", //备注
        verifyStatus: "hold",
        fundingType: "1",
        firstType: "", //资金类型；一级码表
        firstTypeName: "", //一级码表name
        secondType: "", //资金类型；二级码表
        secondTypeName: "", //二级码表name
        thirdType: "", //资金类型；三级码表
        thirdTypeName: "", //三级码表name
        accountInfoParams: [
          //收款单位信息保存
          {
            bankAccount: "", //银行账户
            collectingCompany: "", //收款单位
            depositBank: "", //开户银行账号
            linkId: "", //关联id
            paymentType: "", //付款方式code
            paymentTypeName: "", //付款方式name
            receiveAmount: "", //收款金额
            staffId: "", //收款人id
            staffName: "",
          },
        ],
      },
      editType: false,
      selectPeopleNamesArr: [],
      selectPeopleNames: "",
      selectPeopleIds: [],
      claimListItemIndex: 0, //点击所属inedx值
      createTime: "", //申请时间
      projectName: "", //所属项目名称
      typeColumns: [], //资金用途
      refreshPage: false, // 网络请求失败时显示
      clientType: getDeviceType(), //手机类型
      addType: false, //防止高频点击
      showPaymentTypePicker: false, //转账方式弹框
      showFuKuanTypePicker: false, //付款类型弹框
      showRetinuePicker: false, //随行人员弹框
      innerShow: false, //公司内付款明细
      showRelevanceTypePicker: false, //关联类型弹框
      showPaymentTypeList: [
        //转账方式列表
        {
          dictName: "转账",
          dictCode: "zz",
        },
        {
          dictName: "现金",
          dictCode: "xj",
        },
        {
          dictName: "汇票",
          dictCode: "hp",
        },
        {
          dictName: "保函",
          dictCode: "bh",
        },
      ],
      FuKuanTypeList: [
        //付款类型列表
        {
          dictName: "公司内",
          dictCode: "inner",
        },
        {
          dictName: "公司外",
          dictCode: "outer",
        },
      ],
      incomeAndExpenses: {
        income: "",
        expenses: "",
        contractAmount: "", //合同金额
      },
      marketPercent: "", //营销成本比例
      marketingCost: "", // 营销成本
      marketingCostTotal: "", // 累计营销成本
      remainMarketingCost: "", //剩余营销成本
      technologyPercent: "", //技术成本比例
      technicalCost: "", // 技术成本
      technicalCostTotal: "", // 累计技术成本
      remainTechnicalCost: "", //剩余技术成本
      remainReceptionCost: "", //剩余招待费用
      receptionCostTotal: "", //累计已支出招待费
      receptionCost: "", //招待成本
      receptionPercent: "", //招待成本限额比例
      bidCostTotal: "", //累计投标成本
      showBxTypePicker: false,
      pickerType: "", //判断弹出框显示是支出还是收入
      showProjectMoneyPicker: false, //支出或收入详情弹框默认不显示
      moneydetailList: [], //支出或收入详情列表
      refreshing: false, //无数据显示
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核

      btnLoading: false, //btn是否为加载状态
      sendType: "", //判断是否在抄送列表
      loadingText: "操作中...", //	btn加载状态提示文字
      is_weixn: is_wei(), //是否为微信
    };
  },
  async mounted() {
    if (is_wei()) {
      document.title = "付款申请";
    }
    this.commonId = this.id; //申请Id
    this.$nextTick(() => {
      this.initPage();
    });
  },
  components: {
    refreshPage,
    fileView,
    wxFileView,
  },
  methods: {
    initPage() {
      let _this = this;
      _this.$api.finance.funding
        .detail(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.selectPeopleIds = [];
            _this.selectPeopleNamesArr = [];
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
            _this.createTime = _this.propertyData.createTime.substr(0, 10);
            _this.projectName = res.data.projectName;
            _this.propertyData.paymentTypeName =
              res.data.paymentType == "zz"
                ? "转账"
                : res.data.paymentType == "xj"
                ? "现金"
                :res.data.paymentType == "hp"
                ? "汇票":"保函";;
            _this.propertyData.companyTypeName =
              res.data.companyType == "inner" ? "公司内" : "公司外";
            _this.fundingType = res.data.fundingType;
            _this.propertyData.accountInfoParams = res.data.accountInfoResults;
            if (res.data.accountInfoResults[0]) {
              res.data.accountInfoResults.forEach((item) => {
                _this.selectPeopleIds.push(item.staffId);

                _this.selectPeopleNamesArr.push(item.staffName);
              });
              _this.selectPeopleNames = _this.selectPeopleNamesArr.join(",");
              _this.innerShow = true;
            }
            _this.getCostInfo(res.data.projectId);
            _this.getIncomeAndExpenses(res.data.projectId);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getIncomeAndExpenses(id) {
      let _this = this;
      _this.$api.finance.reimburse
        .incomeAndExpenses({
          projectId: id,
          dateUnitType: "all",
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            console.log(res.data);
            _this.incomeAndExpenses = res.data;

            if (
              res.data.contractAmount != null &&
              parseFloat(res.data.contractAmount) > 0 &&
              res.data.income != null &&
              parseFloat(res.data.income) > 0
            ) {
              let percent = (
                (parseFloat(res.data.income) /
                  parseFloat(res.data.contractAmount)) *
                100
              ).toFixed(2);
              this.$set(
                _this.incomeAndExpenses,
                "income",
                res.data.income + " (" + percent + "%" + ")"
              );
            }
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //项目id获取成本信息I
    getCostInfo(id) {
      let _this = this;
      _this.$api.finance.reimburse
        .getCostInfo({
          projectId: id,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            console.log(res.data, "CostInfo");

            _this.marketPercent = res.data.marketPercent
              ? Number(res.data.marketPercent).toFixed(2)
              : ""; // 营销成本比例
            _this.marketingCost = res.data.marketingCost
              ? Number(res.data.marketingCost).toFixed(2)
              : ""; // 营销成本
            _this.marketingCostTotal = res.data.marketingCostTotal
              ? Number(res.data.marketingCostTotal).toFixed(2)
              : ""; // 累计营销成本
            _this.remainMarketingCost = res.data.remainMarketingCost
              ? Number(res.data.remainMarketingCost).toFixed(2)
              : ""; //剩余营销成本

            _this.technologyPercent = res.data.technologyPercent
              ? Number(res.data.technologyPercent).toFixed(2)
              : ""; //技术成本比例
            _this.technicalCost = res.data.technicalCost
              ? Number(res.data.technicalCost).toFixed(2)
              : ""; // 技术成本
            _this.technicalCostTotal = res.data.technicalCostTotal
              ? Number(res.data.technicalCostTotal).toFixed(2)
              : ""; // 累计技术成本
            _this.remainTechnicalCost = res.data.remainTechnicalCost
              ? Number(res.data.remainTechnicalCost).toFixed(2)
              : ""; // 剩余技术成本

            _this.receptionPercent = res.data.receptionPercent
              ? Number(res.data.receptionPercent).toFixed(2)
              : ""; //招待成本比例
            _this.receptionCost = res.data.receptionCost
              ? Number(res.data.receptionCost).toFixed(2)
              : ""; // 招待成本
            _this.receptionCostTotal = res.data.receptionCostTotal
              ? Number(res.data.receptionCostTotal).toFixed(2)
              : ""; // 累计已招待成本
            _this.remainReceptionCost = res.data.remainReceptionCost
              ? Number(res.data.remainReceptionCost).toFixed(2)
              : ""; // 剩余招待成本

            _this.bidCostTotal = res.data.bidCostTotal
              ? Number(res.data.bidCostTotal).toFixed(2)
              : ""; // 累计投标成本
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getMoneyDetail(name) {
      //跳转项目支出,收入详情
      let _this = this;

      _this.pickerType = name;
      _this.getProjectMoneyDetail();
      _this.showProjectMoneyPicker = true;
    },
    getProjectMoneyDetail() {
      //项目支出或收入详情
      let _this = this;
      _this.$api.project
        .projectMoneyDetail(_this.pickerType, 1, 200, {
          dateUnitType: "all",
          projectId: _this.propertyData.projectId,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.moneydetailList = res.data.list;
          } else {
            _this.$toast(res.msg);
          }
          _this.refreshing = true;
        })
        .catch((err) => {
          _this.refreshing = true;
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.capitalManageDetail {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .dwBox {
    .van-cell {
      .van-cell__title {
        width: 140px;
      }
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
  //添加明细样式
  .claimDetailMain {
    background-color: #fff;
    .fgx {
      width: 100%;
      height: 10px;
      background-color: #f6f6f6;
    }
    p.tit {
      position: relative;
      padding: 0 16px 0 16px;
      font-size: 15px;
      height: 45px;
      line-height: 45px;
      position: relative;
      color: #2581d6;
      font-weight: 700;
      border-bottom: 1px solid #f6f6f6;
    }
    // p.tit:before {
    //   content: "";
    //   position: absolute;
    //   width: 5px;
    //   height: 20px;
    //   background: #2581d6;
    //   top: 13px;
    //   left: 16px;
    // }
    .baseNone::after {
      content: none;
    }
    .claimDetailBox.van-cell-group.van-hairline--top-bottom::after {
      content: none;
    }
  }
  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
  //审批操作样式
  .moneyPicker {
    width: 100%;
    height: 90%;

    background-color: #fff;
    .van-popup__close-icon--top-right {
      top: 5px;
      right: 5px;
      color: red;
    }
    ul {
      width: 100%;
      height: 100%;
      overflow-y: scroll;

      padding: 16px 16px 20px 16px;

      li {
        width: 100%;
        padding: 8px 8px;
        margin: 10px 0;
        background-color: #fff;
        border: 1px solid #eeeeee;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        .incomeInfo {
          p {
            width: 100%;
            overflow: hidden;
            font-size: 15px;
            line-height: 20px;
            margin: 5px 0;
            color: #333;
          }
        }
      }
    }
    .nonePage {
      width: 120px;
      height: 135px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -67px;
      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
}
</style>